import axios from "axios"
import { toast } from "react-toastify";

 export const handleError = (error: any) => {
    if(axios.isAxiosError(error)){
         console.log(error);
        var err = error.response;
        if (err){
            if(Array.isArray(err.data)) {
                console.log(error);
                for(let val of err.data) {
                    toast.warning(val.description);
                }
            }
            else {
                toast.warning(error.response?.data);
            }
        }
    } else if (typeof err?.data.errors === 'object') {
        for(let e in err.data.errors) {
            toast.warning(err.data.errors[e][0]);
        }
    } else if (err?.data){
        toast.warning(err.data);
    }else if (err?.status === 401){
        toast.warning("Please Login")
        window.history.pushState({}, "loginPage", "/loginPage");
    } else if (err) {
        toast.warning(err?.data);
    }
 }